import React from "react";
import { cls } from "@wss/cls";

type RibbonProps = {
  as?: "div" | "a" | "button";
  children: React.ReactNode;
  enhancerClasses?: string;
} & React.HTMLAttributes<HTMLDivElement> &
  React.AnchorHTMLAttributes<HTMLAnchorElement> &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

const Ribbon = ({
  as: Wrapper = "div",
  children,
  className = "",
  enhancerClasses = "",
  ...props
}: RibbonProps) => {
  const wrapperStyles =
    "relative inline-flex transform skew-x-[-13deg] rounded-tl-[4px] rounded-br-[4px] px-[10px] py-1";

  let resetClasses;
  switch (Wrapper) {
    case "button":
      resetClasses =
        "appearance-none border-none p-0 m-0 cursor-pointer focus:outline-none";
      break;
    case "a":
      resetClasses = "no-underline cursor-pointer focus:outline-none";
      break;
    default:
      resetClasses = "";
      break;
  }

  return (
    <Wrapper
      className={cls(`${resetClasses} ${wrapperStyles} ${className}`)}
      {...props}
    >
      {/* 'unskew' child, consumer can add whatever styles to child node if needed */}
      <span
        className={cls(
          `skew-x-[13deg] inline-flex items-center ${enhancerClasses}`,
        )}
      >
        {children}
      </span>
    </Wrapper>
  );
};

export default Ribbon;
